import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChefHat, Home as HomeIcon } from "lucide-react";
import { api, RAYONS, RAYON_META } from "@/lib/api";

export default function SharedList() {
  const { shareId } = useParams();
  const [list, setList] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api.getShared(shareId)
      .then(setList)
      .catch(() => setErr("Liste introuvable ou expirée"));
  }, [shareId]);

  if (err) {
    return (
      <main className="min-h-screen flex items-center justify-center px-6">
        <div className="chibi-card p-10 text-center">
          <div className="text-5xl mb-4">🥲</div>
          <p className="font-display text-xl mb-4">{err}</p>
          <Link to="/" className="chibi-btn-primary inline-flex items-center gap-2">
            <HomeIcon className="w-4 h-4" /> Accueil
          </Link>
        </div>
      </main>
    );
  }
  if (!list) return <div className="min-h-screen flex items-center justify-center">Chargement...</div>;

  const grouped = RAYONS.reduce((acc, r) => {
    acc[r] = list.items.filter((i) => i.rayon === r);
    return acc;
  }, {});

  return (
    <main className="min-h-screen px-4 md:px-6 py-8">
      <div className="max-w-4xl mx-auto">
        <header className="text-center mb-8 chibi-pop">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#A3B18A]/15 text-[#4A3F35] text-sm font-soft mb-4">
            <ChefHat className="w-4 h-4" /> Liste partagée
          </div>
          <h1 className="font-display font-semibold text-4xl md:text-5xl tracking-tight">
            Liste de <span style={{ color: "#E07A5F" }}>courses</span>
          </h1>
        </header>

        {list.items.length === 0 ? (
          <div className="chibi-card p-12 text-center">Liste vide</div>
        ) : (
          <div className="space-y-6">
            {RAYONS.filter((r) => grouped[r].length > 0).map((r) => {
              const meta = RAYON_META[r];
              return (
                <section key={r} className="chibi-card p-6" style={{ background: `linear-gradient(180deg, ${meta.bg} 0%, white 60%)` }}>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="text-2xl">{meta.emoji}</div>
                    <h3 className="font-display font-semibold text-lg" style={{ color: meta.color }}>{r}</h3>
                  </div>
                  <ul className="space-y-2">
                    {grouped[r].map((it) => (
                      <li key={it.id} className="flex items-center gap-3 p-3 rounded-[20px] bg-white border border-[#E8E2D2]">
                        <span className="flex-1 font-medium">{it.name}</span>
                        <span className="text-sm text-[#4A3F35]/70">{it.quantity} {it.unit}</span>
                      </li>
                    ))}
                  </ul>
                </section>
              );
            })}
          </div>
        )}

        <div className="text-center mt-10">
          <Link to="/" className="chibi-btn-ghost inline-flex items-center gap-2">
            <HomeIcon className="w-4 h-4" /> Créer ma propre liste
          </Link>
        </div>
      </div>
    </main>
  );
}
